import { render, staticRenderFns } from "./Ourhistory.vue?vue&type=template&id=35d8efe8&scoped=true&"
import script from "./Ourhistory.vue?vue&type=script&lang=js&"
export * from "./Ourhistory.vue?vue&type=script&lang=js&"
import style0 from "./Ourhistory.vue?vue&type=style&index=0&id=35d8efe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8efe8",
  null
  
)

export default component.exports